import React, { Component } from 'react'
import { connect } from 'react-redux'

// import styles
import './referenceorder.scss'

// Actions
import { LinkOrders, getLinkOrderData, ReferenceOrder } from '../../../actions/orders'
import { getPartnersForOrder } from '../../../actions/shops'

// Utils
import EventEmitter from '../../../utils/events'
import { translation } from '../../../utils/helpers'
import { renderFullDate } from '../../../utils/time'

// import components
import Modal from '../../components/Modal'

// Elements
import DropDown from '../../elements/dropDown'
import Radio from '../../elements/radio'
import LabelWrapper from '../../elements/labelWrapper'
import Divider from '../../elements/divider'
import Inline from '../../elements/inline'

import { ModalIcons } from '../../elements/icons'
import Label from '../../elements/label'

class ReferenceOrderModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      isLoaded: false,
      Partners: [],
      OrderId: this.props.id,
      PartnerName: '',
      PartnerId: 0,
      MoveType: 0,
      TransportBeforePaint: 0,
      Pickup: 0,
      TransportAfterPaint: 0,
      IsWorkProviderOrder: false,
      canSend: false,

      IsReferredIn: false,
      ReferredFromShopName: '',
      ReferredByEmployee: '',
      ReferralRequestTime: null,
      IsMultiReferred: false,
      OriginalShopName: '',
      OriginalShopAddress: '',
      OriginalShopPhone: ''
    }
    this.onInputChange = this.onInputChange.bind(this)
    this.referenceOrder = this.referenceOrder.bind(this)
  }

  componentDidMount () {
    this.GetPartners(this.state.OrderId)
  }

  GetPartners (id) {
    this.props.getPartnersForOrder(id).then((res) => {
      this.setState({
        isLoaded: true,
        ...res.data
      }, () => {
        if (this.state.Partners.length > 0) {
          var partner = this.state.Partners[0]
          this.setState({
            PartnerId: partner.ShopId,
            PartnerName: partner.ShopName,
            canSend: true
          })
        }
        if (this.state.Partners.length === 0 && this.state.IsWorkProviderOrder) {
          let errorText = translation('14877').replace('[WPName]', this.props.item.WPName)
          window.toastr.error(errorText, translation('216'))
          this.props.onClose()
        }
        if (this.state.IsWorkProviderOrder) {
          this.setState({
            MoveType: '1'
          })
        }
      })
    }, () => {
      window.toastr.error(translation('1932'), translation('216'))
      this.props.onClose()
    })
  }

  referenceOrder (e) {
    e.preventDefault()
    if (!this.state.canSend) return null
    let data = {
      OrderId: this.props.id,
      PartnerId: parseInt(this.state.PartnerId),
      MoveType: parseInt(this.state.MoveType),
      TransportBeforePaint: parseInt(this.state.TransportBeforePaint),
      Pickup: parseInt(this.state.Pickup),
      TransportAfterPaint: parseInt(this.state.TransportAfterPaint)
    }
    // console.log('data', data)
    this.setState({
      canSend: false
    }, () => {
      this.props.ReferenceOrder(data).then((res) => {
        this.props.onClose()
        // console.log('update List')
        EventEmitter.emit('updateorderlist', true)
      }, () => {
        // Toastr
        window.toastr.error(translation('960'), translation('216'))
      })
    })
  }

  onInputChange (e) {
    this.setState({ [e.target.name]: e.target.value })
    if (e.target.name === 'PartnerId') {
      for (var i = 0; i < this.state.Partners.length; i++) {
        var partner = this.state.Partners[i]
        if (partner.ShopId === parseInt(e.target.value)) {
          this.state.PartnerName = partner.ShopName
        }
      }
    }
  }

  renderView () {
    let isBodyShop = this.props.auth.departmentType === 1

    const renderPartnerId = () => {
      if (this.state.Partners === undefined) return null
      return (
        <DropDown labelText={translation('1735') + ':'} name='PartnerId' onChange={this.onInputChange} value={this.state.PartnerId}>
          {this.state.Partners.map((val, key) => {
            return (
              <option value={val.ShopId} key={key}>{val.ShopName}</option>
            )
          })}
        </DropDown>
      )
    }

    const renderPaintView = () => {
      const renderMoveType = () => {
        let disabled = this.state.IsWorkProviderOrder
        const onClick = (e) => {
          if (!disabled) return null
          let errorText = translation('14879').replace('[WPName]', this.props.item.WPName)
          window.toastr.error(errorText, translation('216'))
        }
        return (
          <div>
            <Radio labelText={translation('703')} id='move_type-1' name='MoveType' value='1' onChange={this.onInputChange} checked={this.state.MoveType === '1'} disabled={disabled} />
            <Radio labelText={translation('704')} id='move_type-0' name='MoveType' value='0' onChange={this.onInputChange} checked={this.state.MoveType === '0'} disabled={disabled} onClick={onClick} />
          </div>
        )
      }

      const renderTransportBefore = () => {
        return (
          <div>
            <Radio labelText={this.props.auth.user.ShopName} id='transport_before_paint-0' name='TransportBeforePaint' value='0' onChange={this.onInputChange} checked={this.state.TransportBeforePaint === '0'} />
            <Radio labelText={this.state.PartnerName} id='transport_before_paint-1' name='TransportBeforePaint' value='1' onChange={this.onInputChange} checked={this.state.TransportBeforePaint === '1'} />
          </div>
        )
      }

      const renderPickupAt = () => {
        if (this.state.TransportBeforePaint !== '1') return null
        return (
          <LabelWrapper labelText={translation('710')}>
            <Radio labelText={translation('363')} id='pickup-0' name='Pickup' value='0' onChange={this.onInputChange} checked={this.state.Pickup === '0'} />
            <Radio labelText={this.props.auth.user.ShopName} id='pickup-1' name='Pickup' value='1' onChange={this.onInputChange} checked={this.state.Pickup === '1'} />
          </LabelWrapper>
        )
      }

      const renderTransportAfter = () => {
        if (this.state.MoveType !== '0') return null
        return (
          <LabelWrapper labelText={translation('707')}>
            <Divider />
            <Radio labelText={this.props.auth.user.ShopName} id='transport_after_paint-0' name='TransportAfterPaint' value='0' onChange={this.onInputChange} checked={this.state.TransportAfterPaint === '0'} />
            <Radio labelText={this.state.PartnerName} id='transport_after_paint-1' name='TransportAfterPaint' value='1' onChange={this.onInputChange} checked={this.state.TransportAfterPaint === '1'} />
          </LabelWrapper>
        )
      }

      return (
        <div>
          {renderMoveType()}
          <LabelWrapper labelText={translation('705')}>
            <Divider />
            {renderTransportBefore()}
            {renderPickupAt()}
          </LabelWrapper>
          {renderTransportAfter()}
        </div>
      )
    }

    const renderBodyView = () => {
      let {
        IsReferredIn,
        ReferredFromShopName,
        ReferredByEmployee,
        ReferralRequestTime,
        IsMultiReferred,
        OriginalShopName,
        OriginalShopAddress,
        OriginalShopPhone
      } = this.state

      const renderLabel = (dictionaryKey, label, extraCss = '') => {
        return (
          <Inline fillChildNum={[0, 1]} block>
            <span>{translation(dictionaryKey)}</span>
            <span>{label}</span>
          </Inline>
        )
      }

      const renderReferredFrom = _ => {
        return (
          <div>
            <div className='black-h-3-left pg-mb-2'>{translation(719)}</div>
            <LabelWrapper labelText={ReferredFromShopName}>
              {renderLabel(30, ReferredByEmployee)}
              {renderLabel(388, renderFullDate(ReferralRequestTime))}
            </LabelWrapper>
            <Divider />
          </div>
        )
      }

      const renderOriginalShop = _ => {
        return (
          <div>
            <div className='black-h-3-left pg-mb-2'>{translation(17865)}</div>
            <LabelWrapper labelText={OriginalShopName}>
              <Label>{OriginalShopAddress}</Label>
              <Label>{OriginalShopPhone}</Label>
            </LabelWrapper>
            <Divider />
          </div>
        )
      }

      const renderOrderData = _ => {
        let order = this.props.item

        return (
          <div>
            <div className='black-h-3-left pg-mb-2'>{translation(14918)}</div>
            {renderLabel(17866, order.Id)}
            {renderLabel(78, order.RegNumber)}
            {renderLabel(145, translation(order.BrandName.Name))}
            {renderLabel(146, order.Model)}
            <Divider />
          </div>
        )
      }

      const renderEstimatedArival = _ => {
        let order = this.props.item

        return (
          <div>
            <div className='black-h-3-left pg-mb-2'>{translation(14827)}</div>
            {renderLabel(order.ShopName, renderFullDate(order.BodyShopPickupTime, false))}
          </div>
        )
      }

      return (
        <div>
          {IsReferredIn && renderReferredFrom()}
          {IsMultiReferred && renderOriginalShop()}
          {renderOrderData()}
          {renderEstimatedArival()}
        </div>
      )
    }

    return (
      <form>
        {renderPartnerId()}
        {!isBodyShop && renderPaintView()}
        {isBodyShop && renderBodyView()}
      </form>
    )
  }

  render () {
    if (!this.state.isLoaded) return null
    var headerName = this.props.item.Model ? this.props.item.Model : '' + ' ' + this.props.item.RegNumber
    return (
      <div className='referenceorder__modal'>
        <Modal {...this.props}
          header={translation('709') + ' - ' + headerName}
          overflowHidden={this.state.overflowHidden}
          onClose={this.props.onClose}
          icon={ModalIcons.Refer_Order}
          bottomBarProps={{
            disabled: !this.state.canSend,
            actionLabelText: translation('709'),
            onActionClick: this.referenceOrder
          }}
        >
          {this.renderView()}
        </Modal>
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  LinkOrders,
  getLinkOrderData,
  ReferenceOrder,
  getPartnersForOrder
})(ReferenceOrderModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/ReferenceOrderModal/index.js